module.exports = __webpack_public_path__ + "img/g_lei.997e608d.png";